import React from 'react';
import ReactEcharts from 'echarts-for-react';
import { toast } from 'react-toastify';
import ColorPicker from 'src/components/Colorpicker/index-beta';
import { useChartManagement } from 'src/managers/chartManager/stateManagement/management';

class RadarChart extends React.Component {
  constructor(props) {
    super(props);

    const { error } = this.props;
 
    this.configurationError = error;
    this.chartRef = React.createRef();
    this.colorPickerRef = React.createRef();

    this.manager = useChartManagement(this);
  }

  shouldComponentUpdate(nextProps) {
    return this.manager.changesChecker(nextProps);
  }

  onChartReady(echarts) {
    this.echarts = echarts;
  }

  // Caso a api retorne um erro no fetch das configurações de cores, não será possivel abrir
  // o color picker e uma mensagem de erro será apresentada ao usuário.
  onConfigurationError() {
    toast.error(this.configurationError.toString());
  }

  render() {
    const options = this.manager.getOptions();

    const {
      colorPickerColors,
      chartRef,
    } = this.props;

    return (
      <>
        <ReactEcharts
          ref={(echarts) => {
            chartRef.current = echarts;
          }}
          onChartReady={(echarts) => this.onChartReady(echarts)}
          option={options}
          onEvents={{
            dblclick: ((ctx) => this.manager.handleOnDoubleClick(ctx)),
            legendselectchanged: (ctx) => this.manager.handleOnLegendChange(ctx),
          }}
        />
        <ColorPicker
          ref={this.colorPickerRef}
          hideColorPicker={() => this.manager.colorPickerHandler.hideColorPicker()}
          changeBarColor={(newColor) => this.manager.colorPickerHandler.changeColorHandler(newColor)}
          colors={colorPickerColors}
        />
      </>
    );
  }
}

export default RadarChart;
